import React from "react"

type Props = {
  title: string
  subtitle: string
  icon: React.ReactNode
  accent: string
}

const LandingExpectCard: React.FC<Props> = ({ title, subtitle, icon, accent }) => {
  return (
    <article className="group relative flex flex-col items-center gap-4 rounded-2xl border border-[#ebebeb]/80 bg-white/80 px-5 py-6 text-center shadow-[0_8px_30px_-12px_rgba(0,43,122,0.08)] backdrop-blur-sm transition duration-300 hover:-translate-y-1 hover:border-[#9e7e43]/25 hover:shadow-[0_16px_40px_-16px_rgba(0,43,122,0.14)]">
      <div
        className={`relative flex h-14 w-14 items-center justify-center rounded-full ${accent} ring-1 ring-white/60 shadow-sm transition duration-300 group-hover:scale-105`}
      >
        {icon}
        <span className="pointer-events-none absolute inset-0 rounded-full bg-gradient-to-br from-white/40 to-transparent" />
      </div>
      <div className="flex flex-col gap-1">
        <h3 className="font-outfit text-base font-semibold tracking-tight text-[#0d0d0d]">{title}</h3>
        <p className="font-dm-sans text-sm leading-5 tracking-wide text-[#5a5a5a]">{subtitle}</p>
      </div>
    </article>
  )
}

export default LandingExpectCard
